import { render, staticRenderFns } from "./IndexBanner.vue?vue&type=template&id=246c7432&scoped=true&"
import script from "./IndexBanner.vue?vue&type=script&lang=js&"
export * from "./IndexBanner.vue?vue&type=script&lang=js&"
import style0 from "./IndexBanner.vue?vue&type=style&index=0&lang=less&"
import style1 from "./IndexBanner.vue?vue&type=style&index=1&id=246c7432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c7432",
  null
  
)

export default component.exports